<template>
  <div class="first-step-component">
    <address-window/>
  </div>
</template>

<script>
  import AddressWindow from '@/components/order-processing/order-components/address-window/AddressWindow'

  export default {
    name: 'SecondStep',
    components: {
      AddressWindow,
    },
  }
</script>
